import { php } from "@codemirror/lang-php";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material"
import ReactCodeMirror from "@uiw/react-codemirror"
import { useCallback, useState } from "react";

export default function EditCondicionalAuto({
    open,
    handleClose
}: EditCondicionalAutoProps) {

    const [value, setValue] = useState("");
    const onChange = useCallback((val: string) => {
        setValue(val);
    }, []);

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="md"
            fullWidth
        >
            <DialogTitle>
                Editar condicional automática
            </DialogTitle>

            <DialogContent>
                <ReactCodeMirror
                    value={value}
                    height="500px"
                    extensions={[php()]}
                    onChange={onChange}
                    editable
                    placeholder="Digite aqui seu código PHP"
                    theme="dark"
                    basicSetup={{
                        autocompletion: true,
                        foldGutter: true,
                        highlightSpecialChars: true,
                        syntaxHighlighting: true,
                        rectangularSelection: true,
                        indentOnInput: true,
                        completionKeymap: true
                    }}
                />
            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                >
                    Cancelar
                </Button>
                <Button
                    autoFocus
                    variant="contained"
                    onClick={handleClose}
                >
                    Confirmar
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface EditCondicionalAutoProps {
    open: boolean,
    handleClose: () => void
}